<template>
    <notifications position="bottom right"/>
    <template v-if="username && token">
        <div id="main-app">
            <div id="page-content-wrapper">
                <NavBar/>
                <button type="button"
                        class="toggle-navbar animated is-closed btn-displayed">
                    <img :src="navbar_icons[icon_navbar]"
                         id="icon-open-navbar" alt="Abrir menú">
                </button>

<!--                <SideBar/>-->
<!--                <button type="button"-->
<!--                        class="toggle-sidebar animated is-closed btn-displayed-sidebar">-->
<!--                    <img :src="require(`@/assets/icons/arrow-${icon_sidebar}.svg`)"-->
<!--                         id="icon-open-sidebar" alt="Abrir menú">-->
<!--                </button>-->
            </div>
            <div class="container-main-app personalize-scroll">
                <router-view/>
            </div>
        </div>
    </template>
    <AuthView v-else></AuthView>
</template>

<script>

import AuthView from "@/views/Auth/AuthView.vue";
import {computed, onBeforeMount, onBeforeUnmount, onMounted, ref} from "vue";
import {useStore} from "vuex";
import {enforceSession} from "@/utils/auth";
import NavBar from "@/components/Navigation/Navbar.vue";
import SideBar from "@/components/Navigation/SideBar.vue";
import {initSweetNotification} from "@/utils/sweetalert";
import arrow_up from "@/assets/icons/arrow-up.svg";
import arrow_down from "@/assets/icons/arrow-down.svg";

const navbar_icons = {up: arrow_up, down: arrow_down};


export default {
    components: {
        SideBar,
        AuthView,
        NavBar,
    },
    setup() {
        const store = useStore();
        let icon_navbar = ref("up");
        let icon_sidebar = ref("open");
        let username = computed(() => store.getters.getUsername);
        let token = computed(() => store.getters.getToken);

        onBeforeMount(() => {
            existsLoggedUser();
            initSweetNotification()
        })

        const existsLoggedUser = () => {
            if (enforceSession()) {
                store.commit('setUsername', username.value.toLowerCase())
                store.commit('setAicoreToken', token.value)
            }
        }

        // A tab that is never reloaded would otherwise keep its session forever.
        const checkSessionWhenVisible = () => {
            if (document.visibilityState === 'visible') {
                enforceSession()
            }
        }
        onMounted(() => document.addEventListener('visibilitychange', checkSessionWhenVisible))
        onBeforeUnmount(() => document.removeEventListener('visibilitychange', checkSessionWhenVisible))

        $(document).ready(function () {
            var triggerSidebar = $('.toggle-sidebar');
            var is_closed_sidebar = false;

            $('body').on('click', '.toggle-sidebar', function () {
                toggleSidebar();
                $('#main-app').toggleClass('toggledSidebar');
            });



            var trigger = $('.toggle-navbar');
            var is_closed = false;

            $('body').on('click', '.toggle-navbar', function () {
                toggleNavbar();
                $('#main-app').toggleClass('toggled');
            });


            function toggleNavbar() {
                if (is_closed) {
                trigger.removeClass('is-open');
                    trigger.addClass('is-closed');
                } else {
                    trigger.removeClass('is-closed');
                    trigger.addClass('is-open');
                }
                icon_navbar.value = is_closed ? "up" : "down";
                is_closed = !is_closed;
            }

            function toggleSidebar() {
                if (is_closed_sidebar) {
                    triggerSidebar.removeClass('is-open');
                    triggerSidebar.addClass('is-closed');
                } else {
                    triggerSidebar.removeClass('is-closed');
                    triggerSidebar.addClass('is-open');
                }
                icon_sidebar.value = is_closed_sidebar ? "open" : "left";
                is_closed_sidebar = !is_closed_sidebar;
            }
        });

        return {
            username,
            token,
            icon_navbar,
            navbar_icons,
            icon_sidebar,
        }
    }
}
</script>

<style scoped lang="scss">
@import "styles/components/navbar";
@import "styles/components/sidebar";
@import "@/styles/components/sweetalert/notification-toast.scss";

</style>
